import type { AppointmentStatusCode, AppointmentView, ReminderView } from '@wodi/shared';
import type { TagState } from '@wodi/ui';

// Words for appointment states (docs/plans/phase2-appointments.md §6). Every state is a
// word; the tag shape only helps the eye.

export const STATUS_LABELS: Record<AppointmentStatusCode, string> = {
  booked: 'Booked',
  arrived: 'Arrived',
  cancelled: 'Cancelled',
  no_show: 'No-show',
};

export const STATUS_TAGS: Record<AppointmentStatusCode, TagState> = {
  booked: 'pending',
  arrived: 'done',
  cancelled: 'neutral',
  no_show: 'neutral',
};

export const KIND_LABELS = { new: 'New', follow_up: 'Follow-up' } as const;

export function statusTag(a: AppointmentView): { state: TagState; label: string } {
  if (a.status === 'booked' && a.offSchedule) {
    return { state: 'attention', label: 'Outside the schedule' };
  }
  return { state: STATUS_TAGS[a.status], label: STATUS_LABELS[a.status] };
}

export function reminderText(reminder: ReminderView | null): string {
  return reminder === null ? 'No SMS' : reminder.text;
}

export const WEEKDAYS = [
  { id: '1', label: 'Monday' },
  { id: '2', label: 'Tuesday' },
  { id: '3', label: 'Wednesday' },
  { id: '4', label: 'Thursday' },
  { id: '5', label: 'Friday' },
  { id: '6', label: 'Saturday' },
  { id: '7', label: 'Sunday' },
] as const;

/** "Mon 08:00–12:00, Tue 08:00–12:00" */
export function sessionsInWords(
  sessions: readonly { weekday: number; start: string; end: string }[],
): string {
  return sessions
    .map((s) => `${(WEEKDAYS[s.weekday - 1]?.label ?? '').slice(0, 3)} ${s.start}–${s.end}`)
    .join(', ');
}
